import React from 'react';
import axios from 'axios';
import app from '../../index';
import Form from './Form';
import InactiveBg from '../components/InactiveBg';

// campaignEditor component public api
export default class CampaignEditor extends React.Component {
  state = {
    show: false
  };

  close = () => {
    this.setState({
      show: false
    });
  };

  show = () => {
    this.setState({
      show: true
    });
  };

  render() {
    const { show } = this.state;

    if (!show) return null;

    console.log('campaigneditor', this.props);

    return <CampaignEditorPrivate close={this.close} {...this.props} />;
  }
}

// eslint-disable-next-line react/no-multi-comp
class CampaignEditorPrivate extends React.Component {
  props: {
    initProps: {
      id: number,
      campaignName: string,
      description: string,
      targetAmount: number,
      lengthInDays: number,
      daysLeft: number,
      startsAt: string,
      image: string,
      allPhotos: string[],
      allowAuthorToUploadCustomImages: boolean,
      currentDonatedAmount: number,
      kind: string,
      companyName: string
    }
  };

  state = {
    serverErrors: {},
    disableForm: false
  };

  onSubmit = (e, formData) => {
    const { close } = this.props;

    if (Object.keys(formData).length === 0) {
      close();

      app.features.notification('.js-notification', {
        text: 'Vaša kampaň bola úspešne upravená.',
        status: 'success'
      });
    } else {
      this.setState({ disableForm: true });

      formData.action = 'update-campaign';
      formData.campaignId = this.props.initProps.id;

      if (formData.hasOwnProperty('image')) {
        if (isFinite(String(formData.image))) {
          formData.imageId = parseInt(formData.image, 10);
          delete formData.image;
        }
      }
      document.getElementById('loading').style.display = 'block';
      axios.post('/p2p/uprava/', formData).then((response) => {
        window.location.reload();
      }).catch(({ response: { data: { errors } } }) => {
        document.getElementById('loading').style.display = 'none';
        this.setState({
          serverErrors: errors,
          disableForm: false
        });
      });
    }
  };

  onCancel = (e) => {
    e.preventDefault();

    const { close } = this.props;
    close();
  };

  render() {
    const { initProps } = this.props;
    const { serverErrors, disableForm } = this.state;

    return (
      <InactiveBg>
        <Form
          fields={initProps}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          serverErrors={serverErrors}
          disableForm={disableForm}
        />
      </InactiveBg>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignEditor/index.js